import { RiArrowGoBackFill } from "react-icons/ri";
import styled from "styled-components";
import { FaInfoCircle, FaFileAlt } from "react-icons/fa";

// ===========================================
// COMPONENTES PRINCIPAIS
// ===========================================

export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(2px);
  z-index: 1000;
`;

export const Cardo = styled.div`
  ${({ $escolha, $resultado }) =>
    $escolha
      ? `
      width: min(85vw, 800px);
      min-height: 68vh;
      max-height: 68vh;
    `
      : $resultado
      ? `
      width: min(85vw, 1000px);
      min-height: 78vh;
      max-height: 78vh;
      `
      : `
      width: min(85vw, 1500px);
      min-height: 88vh;
      max-height: 88vh;
    `}
  max-width: 1500px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border: none;
  border-radius: 16px;
  padding: 0;
  margin: 0 auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  box-sizing: border-box;

  /* Garantir que todos os filhos respeitem os limites */
  > * {
    box-sizing: border-box;
    min-width: 0; /* Previne overflow de flex items */
  }

  @media (max-width: 768px) {
    width: 95vw;
    min-height: 90vh;
    border-radius: 12px;
  }
`;

export const DivTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: white;
  background: linear-gradient(135deg, #1a2e35 0%, #263654 100%);
  padding: 1.5rem 1rem;
  /* user-select: none; */

  h1 {
    margin: 0 0 1rem 0;
    font-size: clamp(1.5rem, 3vw, 2rem);
    font-weight: 600;
  }

  .status {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: clamp(0.5rem, 2vw, 2rem);
    flex-wrap: wrap;
    width: 100%;

    h2 {
      margin: 0;
      font-size: clamp(0.75rem, 1.5vw, 1rem);
      font-weight: 500;
      transition: all 0.3s ease;
      padding: 0.25rem 0.5rem;
      border-radius: 20px;
      color: #9c9c9c;
      white-space: nowrap;
    }
    .selecionado {
      background-color: rgba(255, 255, 255, 0.2);
      color: white;
      font-weight: 600;
    }
  }
`;

// ===========================================
// FORMULÁRIOS E CONTAINERS
// ===========================================

export const FormDiv = styled.form`
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 1.5rem;
  width: 100%;
  box-sizing: border-box;

  /* Padding ajustado para não conflitar com bordas */
  padding: ${({ $padding }) => ($padding ? "1.5rem 1rem" : "1rem")};

  ${({ $border }) =>
    $border &&
    `
    border-left: 4px solid #1a2e35;
    border-right: 4px solid #263654;
    border-bottom: 4px solid #1a2e35;
    padding-left: calc(1rem + 4px);
    padding-right: calc(1rem + 4px);
  `}

  ${({ $flex }) => $flex && "flex: 1; min-height: 0;"}
  
  ${({ $overflow }) =>
    $overflow &&
    `
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: #1a2e35 #f1f1f1;
    border-radius: 0px 0px 10px 10px;
    &::-webkit-scrollbar {
      width: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #1a2e35;
      border-radius: 4px;
    }
  `}
`;

export const DivMain = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0; /* Importante para flex items */
  overflow: hidden;
  box-sizing: border-box;

  ${({ $escolha }) => $escolha && `justify-content: flex-start;`}
  ${({ $isRevisaoMode }) =>
    !$isRevisaoMode &&
    `
      border-left: 4px solid #1a2e35;
      border-right: 4px solid #263654;
      border-bottom: 4px solid #1a2e35;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
    `}
`;

export const ContainerTable = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0; /* Crucial para flex containers */
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;

  ${({ $loading }) =>
    $loading &&
    `
    align-items: center;
    justify-content: center;
  `}

  ${({ $isRevisaoMode }) =>
    !$isRevisaoMode
      ? `
        border-left: 4px solid #1a2e35;
        border-right: 4px solid #263654;
        border-bottom: 4px solid #1a2e35;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        // user-select: none;
      `
      : `
        border-bottom: 4px solid #1a2e35;
        margin-bottom: 4px;
        width: calc(100% - 0px);
      `}
  
  /* Scrollbar customizada */
  scrollbar-width: thin;
  scrollbar-color: #1a2e35 #f1f1f1;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #1a2e35;
    border-radius: 4px;
  }
`;

export const DivSave = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.5rem 1.5rem;
  gap: 1rem;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  box-sizing: border-box;
  flex-shrink: 0; /* Impede que seja comprimido */

  /* Garantir que não ultrapasse os limites */
  min-height: fit-content;
  max-width: 100%;

  @media (max-width: 768px) {
    padding: 1rem;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.75rem;
  }
`;

// ===========================================
// ELEMENTOS DE TEXTO E INFORMAÇÕES
// ===========================================

export const DivText = styled.h2`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #6c757d;
  font-size: 1.1rem;
  font-weight: 500;
  padding: 2rem;
  /* user-select: none; */

  @media (max-height: 800px) {
    height: 20vh;
    min-height: 150px;
  }
`;

export const DivText2 = styled(DivText)`
  font-size: 1rem;
  padding: 1rem;
`;

export const DivideTable = styled.div`
  width: 100%;
  min-height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a2e35 0%, #263654 100%);
  color: white;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  cursor: pointer;
  padding: 1rem;
  transition: all 0.3s ease;
  /* user-select: none; */

  &:hover {
    background: linear-gradient(135deg, #263654 0%, #1a2e35 100%);
    transform: translateY(-1px);
  }

  svg {
    font-size: 1.2rem;
  }
`;

export const NoSelected = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  user-select: none;
`;

export const Infos = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 1rem;
  width: 100%;
  font-weight: 600;
  padding: 1rem;
  box-sizing: border-box;

  /* Prevenir overflow */
  min-width: 0;
  overflow-x: auto;

  ${({ $escolha }) =>
    $escolha &&
    `
      flex-wrap: wrap;
      justify-content: flex-start;
    `}
  ${({ $resumo }) =>
    $resumo &&
    `
    flex-direction: column;
    padding: 1rem 2rem;
    overflow-x: hidden;
    align-items: stretch;
  `}

  @media (max-width: 1348px) {
    gap: 0.5rem;
    padding: 0.75rem;
  }
  @media (max-width: 1148px) {
    flex-wrap: wrap;
  }
  @media (max-width: 788px) {
    ${({ $resumo }) => $resumo && `padding: 0.75rem 1rem;`}
  }
  @media (max-width: 648px) {
    flex-direction: column;
  }
`;

export const CursoTurmaDiscInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0.75rem;
  font-size: 1.1rem;
  color: #1a2e35;

  border-radius: 8px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-width: 150px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  p {
    font-size: 0.9rem;
    font-weight: 400;
    color: #495057;
    margin: 0.25rem 0 0 0;
    word-break: break-word;
  }

  @media (max-width: 1200px) {
    font-size: 1rem;
    p {
      font-size: 0.8rem;
    }
  }

  @media (max-width: 788px) {
    font-size: 0.9rem;
    min-width: 120px;
    p {
      font-size: 0.75rem;
    }
  }
`;

// Novo componente para os itens do resumo
export const ResumoInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: #1a2e35;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e9ecef;
  border-left: 4px solid #1a2e35;
  width: 100%;
  /* Removido min-height fixo - deixa o conteúdo definir a altura */
  height: auto;
  transition: all 0.3s ease;
  box-sizing: border-box;
  margin-bottom: 0.5rem;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    border-left-color: #2c5aa0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  p {
    font-size: 0.9rem;
    font-weight: 400;
    color: #495057;
    margin: 0.75rem 0 0 0;
    padding: 0.75rem;
    background: rgba(248, 249, 250, 0.8);
    border-radius: 6px;
    border: 1px solid #e9ecef;
    width: 100%;
    box-sizing: border-box;
    line-height: 1.6;

    /* CRÍTICO: Preservar formatação original do texto */
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;

    /* Melhorar legibilidade */
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;

    /* Altura dinâmica baseada no conteúdo */
    height: auto;
    min-height: auto;

    &:empty::before {
      content: "Não informado";
      color: #adb5bd;
      font-style: italic;
      white-space: normal;
    }

    /* Caso tenha conteúdo mas seja apenas espaços em branco */
    &:not(:empty):not([data-has-content]) {
      min-height: 1.5rem;
    }
  }

  @media (max-width: 1200px) {
    font-size: 0.95rem;
    padding: 0.875rem;

    p {
      font-size: 0.85rem;
      padding: 0.625rem;
    }
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.75rem;

    p {
      font-size: 0.8rem;
      padding: 0.5rem;
      line-height: 1.5;
    }
  }
`;

// ===========================================
// ELEMENTOS DE FORMULÁRIO
// ===========================================

export const DivTextarea = styled.div`
  width: calc(100% - 1rem);
  margin-bottom: 1rem;

  label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: 0.9rem;
    font-weight: 600;
    padding: 0.5rem 0.6rem;
    color: white;
    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
    border-radius: 8px 8px 0 0;
    margin: 0;

    p {
      margin: 0;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      small {
        font-size: 0.75rem;
        color: #e9ecef;
        font-weight: 400;
      }
    }

    span {
      font-size: 0.75rem;
      color: #e9ecef;
      font-weight: 400;
    }
  }
`;

export const InputTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 0.5rem;
  border: 1px solid #babec2;
  border-top: none;
  border-radius: 0 0 8px 8px;
  background-color: #ffffff;
  font-size: 0.9rem;
  font-family: inherit;
  line-height: 1.5;
  resize: none;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #1a2e35;
    box-shadow: 0 0 0 2px rgba(26, 46, 53, 0.1);
  }

  &:disabled {
    background-color: #f8f9fa;
    color: #6c757d;
    cursor: not-allowed;
  }
`;

// ===========================================
// DRAG AND DROP E ARQUIVOS
// ===========================================

export const DragAndDropArea = styled.div`
  width: calc(100% - 2rem);
  height: calc(100% - 2rem);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  background: ${({ dragActive }) =>
    dragActive
      ? "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)"
      : "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)"};
  border: 2px dashed ${({ dragActive }) => (dragActive ? "#2196f3" : "#dee2e6")};
  border-radius: 12px;
  transition: all 0.3s ease;
  margin: 1rem;
  box-sizing: border-box;

  &:hover {
    border-color: #1a2e35;
    background: linear-gradient(135deg, #e8f4f8 0%, #d1ecf1 100%);
  }
`;

export const DragAndDropArea2 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  max-width: calc(60% - 2rem);
  border: 2px dashed #dee2e6;
  border-radius: 12px;
  padding: 1.5rem 2rem;
  background: ${({ dragActive }) =>
    dragActive
      ? "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)"
      : "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)"};
  transition: all 0.3s ease;
  margin: 1rem auto 0 auto;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    max-width: calc(90% - 1rem);
  }
`;

export const Instructions = styled.div`
  text-align: center;
  padding: 2rem;
  color: #495057;
  font-size: 1rem;
  line-height: 1.6;

  p {
    margin: 0;
    max-width: 700px;
  }

  strong {
    color: #1a2e35;
    font-weight: 600;
  }
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #495057;

  span {
    font-weight: 600;
    text-align: center;
    word-break: break-word;
    max-width: 100%;
  }
`;

export const FileDetails = styled.div`
  font-size: 0.7rem;
  color: #6c757d;
  text-align: center;
`;

export const HiddenFileInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;

export const PdfEmbed = styled.iframe`
  width: 100%;
  height: 100%;
  flex: 1;
  border: none;
  min-height: ${({ $isRevisaoMode }) => ($isRevisaoMode ? "600px" : "400px")};
  border-radius: ${({ $isRevisaoMode }) => ($isRevisaoMode ? "0" : "0 0 8px 8px")};
`;

// ===========================================
// ÍCONES E ELEMENTOS VISUAIS
// ===========================================

export const GoBack = styled(RiArrowGoBackFill)`
  color: #1a2e35;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: #2c5aa0;
    transform: scale(1.1);
  }
`;

export const InfoIcon = styled(FaInfoCircle)`
  color: #1a2e35;
  font-size: 1.1rem;
`;

export const DocumentIcon = styled(FaFileAlt)`
  color: #2c5aa0;
  font-size: 1.1rem;
`;

// ===========================================
// COMPONENTES DE RESUMO
// ===========================================

export const ResumoContainer = styled.div`
  width: calc(95% - 2rem);
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 1rem auto;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: calc(98% - 1rem);
    padding: 1rem;
    gap: 1.5rem;
  }
`;

export const InfoBasicaSection = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border-left: 4px solid #1a2e35;
  transition: all 0.3s ease;
  height: auto; /* Altura dinâmica */

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 768px) {
    padding: 1rem; /* Reduzido para mobile */
  }
`;

export const ComplementosSection = styled(InfoBasicaSection)`
  border-left-color: #2c5aa0;

  /* Seção de complementos pode ter mais conteúdo */
  padding: 1.25rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const SectionTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.3rem;
  font-weight: 600;
  color: #1a2e35;
  margin: 0 0 2rem 0;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    gap: 0.5rem;
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const InfoCard = styled.div`
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 1.5rem;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    border-color: #1a2e35;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const InfoLabel = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.75rem;
`;

export const InfoValue = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: #1a2e35;
  line-height: 1.4;
  word-wrap: break-word;
`;

export const ComplementosList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem; /* Reduzido o gap entre itens */

  /* Cada item se ajusta ao seu conteúdo */
  > * {
    height: auto;
  }
`;

export const ComplementoItem = styled.div`
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;

  /* Altura dinâmica baseada no conteúdo */
  height: auto;
  min-height: auto;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    border-color: #2c5aa0;
  }
`;

export const ComplementoHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  background: linear-gradient(135deg, #1a2e35 0%, #263654 100%);
  color: white;
  padding: 1.5rem;
  font-weight: 600;

  @media (max-width: 768px) {
    padding: 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
`;

export const ComplementoNumber = styled.div`
  background: rgba(255, 255, 255, 0.2);
  color: white;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.3);

  @media (max-width: 768px) {
    width: 2rem;
    height: 2rem;
    font-size: 0.8rem;
  }
`;

export const ComplementoTitulo = styled.div`
  font-size: 1rem;
  line-height: 1.4;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

export const ComplementoConteudo = styled.div`
  padding: 1.5rem;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #495057;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.05);

  /* Altura dinâmica baseada no conteúdo */
  height: auto;
  min-height: auto;

  /* CRÍTICO: Preservar formatação original do texto */
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;

  /* Melhorar legibilidade */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;

  &:empty::before {
    content: "Não informado";
    color: #adb5bd;
    font-style: italic;
    white-space: normal;
    display: block;
    min-height: 1.5rem;
    line-height: 1.5rem;
  }

  /* Para conteúdo que existe mas pode ser apenas espaços */
  &:not(:empty):not([data-has-content]) {
    min-height: 1.5rem;
  }

  @media (max-width: 768px) {
    padding: 1rem;
    font-size: 0.9rem;
  }
`;
